import React from "react";
import { useTranslation } from "react-i18next";
import { Radio } from "semantic-ui-react";
import parse from "html-react-parser";

interface Props {
  questionHeading: string;
  invalid: boolean;
  value: number | null;
  onValueChange: (value: number, text: string) => void;
}

export default function LikertControl({ questionHeading, onValueChange, invalid, value }: Props) {
  const { t } = useTranslation("common");
  const changeValue = (newValue: number, text: string) => {
    onValueChange(newValue, text);
  };
  return (
    <>
      <div className={invalid?"negative-message":"question-wrapper"}>
      <label className="statement">{parse(questionHeading)}</label>
      <ul className="likert">
        <li>
          <Radio
            label={t("Likert.StronglyDisagree")}
            onChange={() => changeValue(5, "StronglyDisagree")}
            checked={value === 5}
          />
        </li>
        <li>
          <Radio
            label={t("Likert.Disagree")}
            onChange={() => changeValue(4, "Disagree")}
            checked={value === 4}
          />
        </li>
        <li>
          <Radio
            label={t("Likert.Neutral")}
            onChange={() => changeValue(3, "Neutral")}
            checked={value === 3}
          />
        </li>
        <li>
          <Radio
            label={t("Likert.Agree")}
            onChange={() => changeValue(2, "Agree")}
            checked={value === 2}
          />
        </li>
        <li>
          <Radio
            label={t("Likert.StronglyAgree")}
            onChange={() => changeValue(1, "StronglyAgree")}
            checked={value === 1}
          />
        </li>
      </ul>
      </div>
    </>
  );
}
